<div class="pdh-wrap">
  <div class="pdh-search-box">
    <i class="ri-search-line"></i>
    <input type="text" [(ngModel)]="searchTerm" placeholder="{{ 'searchByName' | translate }}" />
    <i class="ri-close-line pdh-search-clear" *ngIf="searchTerm" (click)="searchTerm = ''"></i>
  </div>

  <div class="pdh-tabs">
    <button type="button" class="pdh-tab" [class.active]="activeFilter === 'ALL'" (click)="setFilter('ALL')">{{ 'all' | translate }} ({{ countAll }})</button>
    <button type="button" class="pdh-tab" [class.active]="activeFilter === 'PDF'" (click)="setFilter('PDF')">{{ 'pdf' | translate }} ({{ countPdf }})</button>
    <button type="button" class="pdh-tab" [class.active]="activeFilter === 'IMAGE'" (click)="setFilter('IMAGE')">{{ 'images' | translate }} ({{ countImage }})</button>
    <button type="button" class="pdh-tab" [class.active]="activeFilter === 'DOC'" (click)="setFilter('DOC')">{{ 'docs' | translate }} ({{ countDoc }})</button>
  </div>

  <h4 class="pdh-section-title" *ngIf="!loading && filteredDocuments.length">{{ 'recentUploads' | translate }}</h4>

  <div class="pdh-list" *ngIf="!loading; else pdhLoading">
    <div class="pdh-empty" *ngIf="!filteredDocuments.length && !error">
      <div class="pe-icon"><i class="ph ph-folder-open"></i></div>
      <div class="pe-title">{{ 'dataNotFound' | translate }}</div>
    </div>
    <div class="pdh-error" *ngIf="error">{{ error }}</div>

    <div class="pdh-card" *ngFor="let doc of filteredDocuments" (click)="openDocument(doc)">
      <div class="pdh-card-icon" [ngClass]="'pdh-icon-' + doc.type"><i [class]="iconClass(doc)"></i></div>
      <div class="pdh-card-body">
        <div class="pdh-card-name">{{ doc.name }}</div>
        <div class="pdh-card-meta">{{ doc.date | date: 'dd MMM, y' }} &middot; {{ doc.createdBy }}</div>
      </div>
    </div>
  </div>

  <ng-template #pdhLoading>
    <div class="pdh-list">
      <div class="pdh-card pdh-card-skeleton" *ngFor="let n of [1,2,3,4,5,6]"></div>
    </div>
  </ng-template>
</div>

<!-- Image preview — small centered window, same pattern as diary's media viewer -->
<div class="pdh-viewer-overlay" *ngIf="previewImageUrl" (click)="closePreview()">
  <div class="pdh-image-viewer-window" (click)="$event.stopPropagation()">
    <button type="button" class="pdh-viewer-close" (click)="closePreview()"><i class="ri-close-line"></i></button>
    <img [src]="previewImageUrl" class="pdh-image-viewer-img" alt="" />
  </div>
</div>

<!-- PDF preview -->
<div class="pdh-viewer-overlay" *ngIf="previewPdfUrl" (click)="closePreview()">
  <div class="pdh-pdf-viewer-window" (click)="$event.stopPropagation()">
    <div class="pdh-pdf-viewer-header">
      <button type="button" class="pdh-viewer-close pdh-viewer-close-light" (click)="closePreview()"><i class="ri-close-line"></i></button>
    </div>
    <iframe [src]="previewPdfUrl" class="pdh-pdf-viewer-frame"></iframe>
  </div>
</div>

<!-- Unsupported file type — no in-app viewer exists -->
<div class="pdh-modal-overlay" *ngIf="unsupportedDoc" (click)="closePreview()">
  <div class="pdh-modal" (click)="$event.stopPropagation()">
    <h3 class="pdh-modal-title">{{ 'cannotPreviewFile' | translate }}</h3>
    <p class="pdh-modal-text">{{ unsupportedDoc.name }}</p>
    <div class="pdh-modal-actions">
      <button type="button" class="pdh-modal-btn pdh-modal-btn-secondary" (click)="closePreview()">{{ 'cancel' | translate }}</button>
      <button type="button" class="pdh-modal-btn pdh-modal-btn-primary" (click)="downloadUnsupportedDoc()">{{ 'download' | translate }}</button>
    </div>
  </div>
</div>
